<div class="card flex justify-content-center">
    <p-breadcrumb class="max-w-full" [model]="getBreadcrumbs()"></p-breadcrumb>
</div>
<div class="container page-title">
    <div class="flex-box">
        <div class="fr-flex__container">
            <div class="fr-flex__col-6">
                <h1>Audit <span class="number_of_records"> ({{ totalRecordCount }} Records) </span></h1>
            </div>
            <div class="fr-flex__col-6">
                <button class="btn btn-outline-primary pull-right" (click)="refreshClick()">Refresh</button>
            </div>
        </div>
    </div>

    <div class="fr-flex__container filter-bg">
        <div class="fr-flex__col-3">
            <div class="fr-form__group margin-zero">
                <label>Start DateTime</label>
                <p-calendar appendTo="body" [(ngModel)]="startDate" [showTime]="true" [showIcon]="true" placeholder="Start DateTime"></p-calendar>
            </div>
        </div>
        <div class="fr-flex__col-3">
            <div class="fr-form__group margin-zero">
                <label>End DateTime</label>
                <p-calendar appendTo="body" [(ngModel)]="endDate" [showTime]="true" [showIcon]="true" placeholder="End DateTime"></p-calendar>
            </div>
        </div>
        <div class="fr-flex__col-2">
            <button class="btn btn-primary" (click)="onSearch()">Search</button>
        </div>
        <div class="fr-flex__col-2">
            <a class="btn btn-primary-link" (click)="onClearFilters()"> Clear Filters </a>
        </div>
    </div>

    <p-table class="primeng-table-custom" [resizableColumns]="true" columnResizeMode="expand" styleClass="p-datatable-striped p-datatable-gridlines"
    [scrollable]="true"
    dataKey="id"
    [value]="filteredAuditList"
    [lazy]="true"
    (onLazyLoad)="loadAuditList($event)"
    (onRowExpand)="onRowExpand($event.data)"
    [paginator]="true"
    [rows]="rows"
    [totalRecords]="totalRecordCount"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Entries"
    [rowsPerPageOptions]="[10, 20, 50, 100, 200]"
     [tableStyle]="{ 'min-width': '50rem' }">
        <ng-template pTemplate="header">
            <tr>
                <th id="auditExpand" style="width: 3rem"></th>
                <th id="auditRecordId" pResizableColumn>Audit Record</th>
                <th id="auditOperationType" pResizableColumn>Operation Type</th>
                <th id="auditEntityIdentifier" pResizableColumn>Record ID</th>
                <th id="auditFromService" pResizableColumn>From Service</th>
                <th id="auditOperator" pResizableColumn>User</th>
                <th id="auditOperationDate" pResizableColumn>Operation Date and Time</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-record let-expanded="expanded">
            <tr>
                <td>
                    <button type="button" pButton [pRowToggler]="record" class="p-button-text p-button-rounded p-button-plain"
                        [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
                </td>
                <td>{{ record.recordId }}</td>
                <td>{{ record.operationType }}</td>
                <td [pTooltip]="record.entityIdentifier && record.entityIdentifier.length > 20 ? record.entityIdentifier : ''" tooltipPosition="top">{{ record.entityIdentifier }}</td>
                <td>{{ record.fromService }}</td>
                <td>{{ record.operatorUsername }}</td>
                <td>{{ record.operationDate }}</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="rowexpansion" let-record>
            <tr>
                <td colspan="7">
                    <div class="field-diff-wrapper">
                        <div *ngIf="loadingDetailByRecord[record.id]">Loading field changes...</div>
                        <table class="field-diff-table" *ngIf="!loadingDetailByRecord[record.id]">
                            <thead>
                                <tr>
                                    <th>Field Name</th>
                                    <th>Before Modification</th>
                                    <th>After Modification</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let change of fieldModificationsByRecord[record.id]">
                                    <td>{{ change.fieldName }}</td>
                                    <td>{{ change.oldValue || '-' }}</td>
                                    <td>{{ change.newValue || '-' }}</td>
                                </tr>
                                <tr *ngIf="!fieldModificationsByRecord[record.id]?.length">
                                    <td colspan="3" class="text-center">No field changes recorded</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="7" class="text-center">
                    <span *ngIf="!isGridFiltered">No Records</span>
                    <span *ngIf="isGridFiltered">No records on this page match the column filters. Column filters search only the page currently loaded &ndash; use the date range above to search all records.</span>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
